module.exports = __webpack_public_path__ + "media/images/icon_list/double_chevron_left-21ae5ae86748bdc5b2c538030fa1b7b5.svg";